import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Breadcrumb, Form, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Decrypt } from '../../utils/Helper';
import { GrokLoading } from "../page-layout/loading/Loading";
import { GetAllCollege } from '../../utils/axios/StudentAPI';
import { GetSelectedBranches } from '../../utils/axios/LookUpAPI';
import { GetStudent, DeleteStudents } from '../../utils/axios/StudentAPI';
import { TimerAlert, ConfirmAlert, getRoles } from '../../utils/swtAlert';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import { GetOrganization } from '../../utils/axios/CompanyAPI';
import { GetLookUps } from '../../utils/axios/LookUpAPI';
import { ORGANIZATION_TYPE,IS_GROVATOR } from "../constants/constants";

const GrovatroLab = () => {
    const navigate = useNavigate();
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const [role, setRole] = useState('');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [college, setCollege] = useState("");
    const [collegelist, setCollegelist] = useState([]);
    const [grovatorcollegetype,setgrovatorcollegetype] = useState([]);
    const [branch, setBranch] = useState("");
    const [branchlist, setBranchlist] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [studentType, setStudentType] = useState(true); 
    const [isGrovator,setisGrovator] = useState();


    const columns = [
        {
            name: "Name",
            selector: row => row.DisplayName,
            sortable: true,
            cell: row => row.DisplayName,
        },
        {
            name: "Gender",
            selector: row => row?.Gender?.name ? row?.Gender?.name : "",
            sortable: true,
            cell: row =>  row?.Gender?.name ? row?.Gender?.name : "",
        },
        {
            name: "Branch",
            selector: row => row.Branch.name,
            sortable: true,
            cell: row => row.Branch.name,
        },
        {
            name: "Year",
            selector: row => row.Year.name,
            sortable: true,
            cell: row => row.Year.name,
        },
        {
            name: "Semester",
            width: "120px",
            selector: row => row.Semester.name,
            sortable: true,
            cell: row => row.Semester.name,
        },
        {
            name: "Email",
            width: "240px",
            selector: row => row.Email,
            sortable: true,
            cell: row => row.Email,
        },
        {
            name: "Contact Number",
            width: "150px",
            selector: row => row.MobileNumber,
            sortable: true,
            cell: row => row.MobileNumber,
        },
        {
            name: "Actions",
            width: "180px",
            cell: (row) => (<>
                <button className="btn btn-link ms-1" title="Edit" onClick={() => handleStudentEdit(row._id)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z"></path></svg></span></button>
                <button className="btn btn-link ms-1" title="Delete" onClick={() => handleStudentDelete(row._id)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"></path></svg></span></button>
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    const tableData = {
        columns,
        data,
    };

    const addGrovatorLabStudents = () => {
        navigate('/grovatorlabdetails', { state: { studentid: null } });
    }

    const handleStudentEdit = (id) => {
        navigate('/grovatorlabdetails', { state: { studentid: id } });
    }
    const BackBtn = () => {
        navigate('/home');
    }

    const addRefresh = () => {
        navigate('/home', { state: { studentid: null } });
    }

    const handleStudentDelete = async (id) => {
        ConfirmAlert("You want to Delete Student!", 'Are you sure?', 'warning', 'Yes, delete this Student!').then(
            async (result) => {
                if (result.isConfirmed) {
                    var response = await DeleteStudents(id);
                    if (response) {
                        TimerAlert("success", "Student Deleted Successfully", "success");
                        getAllStudents(college);
                    }
                }
            }
        )
    }

    const collegeNameChange = async (e) => {
        setCollege(e.target.value);
        if (e.target.value !== "") {
            let branchesPayload = {
                OrganizationId: e.target.value
            }
            setLoading(true);
            var response = await GetSelectedBranches(branchesPayload);
            setBranchlist(response.data);
            setLoading(false);
        }
        setBranch("");
        // getAllStudents(e.target.value);
    }

    const changeBranches = (e) => {
        setBranch(e.target.value);
        // getAllStudents(college, e.target.value);
    }

    const getAllStudents = async (orgid, branchid) => {
        let labStudentPayload = {
            OrganizationId: orgid,
            IsGrovatorLab: isGrovator,
            Branch: branchid === "" ? null : branchid

        }
        setLoading(true);
        var organinizationResponse = await GetStudent(labStudentPayload);
        console.log(organinizationResponse.data);
        setData(organinizationResponse.data);
        setFilteredData(organinizationResponse.data);
        setLoading(false);
    }

    const getBranches = async () => {
        let branchesPayload = {
            OrganizationId: userInfo.OrganizationId
        }
        setLoading(true);
        var response = await GetSelectedBranches(branchesPayload);
        setBranchlist(response.data);
        setLoading(false);
    }

    const handleStudentTypeChange = () => {
        setStudentType(!studentType);
        setCollege("");
        setBranch("");
        setBranchlist([]);
        setData([]);
    }

    const bindFormPreloadData = async () => {
        setLoading(true);
        let grovatorcollegepayload ={
            Type:9
        }
        var grovatorcollegeResponse = await GetLookUps(grovatorcollegepayload);
        console.log(grovatorcollegeResponse);
        setgrovatorcollegetype(grovatorcollegeResponse.data);
        setLoading(false);

    };

    const handleorgtypechange = (e) =>{
        setData('');
        setisGrovator(e);
        if(e == IS_GROVATOR.ASSOCIATED){
            getOrganization(true);
        }
        else if(e == IS_GROVATOR.NON_ASSOCIATED){
            getOrganization(false);
        }
        else{
            setData('');
        }
    }
    const getOrganization = async (groktype) => {
        console.log(groktype);
        setLoading(true)
        let organizationPayload = {
            OrganizationType: ORGANIZATION_TYPE.COLLEGE,
            isGrovator: groktype
        }
        var organinizationResponse = await GetOrganization(organizationPayload);
        setCollegelist(organinizationResponse.data);
        setLoading(false);
    }
    useEffect(() => {
        if (college !== "") {
            getAllStudents(college, branch)
        }
    }, [college, studentType, branch]);

    useEffect(() => {
        bindFormPreloadData();
        const role = getRoles(userInfo);
        setRole(role);
        if (role === 'College') {
            getAllStudents(userInfo.OrganizationId);
            getBranches();
        }
        // document.querySelectorAll(".navbar-nav .nav-item a")[4].classList.add("active")
    }, [])


    return (
        <div className='page'>
            {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />
            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center pb-1'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}>Home</Breadcrumb.Item>
                                    <Breadcrumb.Item active>Grovator</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button className='nave-icon' variant='outline' size='sm' title='students'>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"></path></svg></span>
                                </Button>
                                <h2 className="page-title"> Grovator/Non-Grovator</h2>
                            </Col>
                            <Col className="mb-1 me-3 col-md-auto">
                                <button className='newBtn_style' onClick={() => BackBtn()}>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                    &nbsp;&nbsp;Back
                                </button>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}
                    <div className='py-3'>
                        <div className='card mb-3 mb-lg-5 '>
                            {/* Header */}
                            <div className='card-header'>
                                <Row className="row justify-content-between align-items-center flex-grow-1">
                                    <Col className='col-md mb-2 md-mb-0'>
                                        <div className="d-flex justify-content-between align-items-center">
                                            {/* <div className="card-title fw-bold mb-0 switchButton">
                                                <BootstrapSwitchButton
                                                    checked={studentType}
                                                    onlabel='Grovator'
                                                    onstyle='primary'
                                                    offlabel='Non-grovator'
                                                    offstyle='secondary'
                                                    style='w-100 mx-5'
                                                    onChange={handleStudentTypeChange}
                                                />
                                            </div> */}
                                        </div>
                                    </Col>
                                    {/* End Col */}
                                    <Col lg={2}>
                                        <Form.Select as="select" value={isGrovator} onChange={(e) => handleorgtypechange(e.target.value)} >
                                            <option value={""}>College Type</option>
                                            {grovatorcollegetype.map((item) => 
                                            <option value={item._id} key={item._id}>{item.Name}</option>
                                            )}
                                        </Form.Select>
                                    </Col>
                                    {(role === 'Grok Admin') && <Col lg={3} md-4> 
                                        <Form.Select as="select" value={college} onChange={collegeNameChange}>
                                            <option value={""}>Associate Colleges</option>
                                            {collegelist.map(item => (
                                                <option key={item._id} value={item._id}>{item.Name}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>}
                                    <Col lg={3}>
                                        <Form.Select as="select" value={branch} onChange={changeBranches} >
                                            <option value={""}>Branch</option>
                                            {branchlist.map(item => (
                                                <option key={item._id} value={item._id}>{item.Name}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                </Row>
                                {/* End Row */}
                            </div>
                            <div>
                                <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
                                    <Modal.Header closeButton>
                                        <Modal.Title><b>Upload Students Data</b> </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div>
                                            <Row className="align-items-center">
                                                <Col>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label> Student data</Form.Label>
                                                        <div className="col">
                                                            <Form.Control type="file" />
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Row>
                                            <Col>
                                                <Button variant="secondary" type="button" size="sm" onClick={handleClose}>Cancel</Button>
                                            </Col>
                                            <Col className="col-md-auto">
                                                <Button variant="primary" color="primary" size="sm"> Upload</Button>
                                            </Col>
                                        </Row>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                            <div className='taablist mb-3'>
                                <DataTableExtensions {...tableData}>
                                    <DataTable
                                        columns={columns}
                                        data={data}
                                        fixedHeader
                                        defaultSortField="id"
                                        defaultSortAsc={false}
                                        pagination
                                        noDataComponent={(role === 'Grok Admin') ?
                                            (<span className='m-2'>Please select College Name and branch</span>) :
                                            (<span className='m-2'>There are no records to display</span>)}
                                        paginationPerPage={20}
                                        paginationRowsPerPageOptions={[20, 30, 50, 100]}
                                    />
                                </DataTableExtensions>
                            </div>
                        </div>
                    </div>
                </Container>
                <Footer />
            </div>
        </div>
    )
}

export default GrovatroLab; 
